var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"header-1"},[_c('div',{staticClass:"copyright"},[_vm._v("\n      ©"+_vm._s(_vm.$l.copyright)+"\n    ")]),_c('manual')],1),_c('patent-pending')],1)}
var staticRenderFns = []

export { render, staticRenderFns }